<div class="request-status-toolbar">
  <div class="request-status-tabs" role="tablist" aria-label="Policy status filters">
    <button
      *ngFor="let tab of policyStatusTabs"
      type="button"
      class="request-status-tabs__btn"
      [class.request-status-tabs__btn--active]="selectedPolicyStatus === tab.value"
      [attr.aria-selected]="selectedPolicyStatus === tab.value"
      (click)="setPolicyStatusTab(tab.value)"
    >
      {{ tab.label }}
    </button>
  </div>
  <div class="request-status-toolbar__actions" *ngIf="showAddPolicyButton">
    <button
      type="button"
      class="created-policies-add-btn"
      (click)="openAddPolicyModal()"
    >
      Add New Policy
    </button>
  </div>
</div>

<app-table
  [columns]="columns"
  [data]="rows"
  [pagination]="pagination"
  [loading]="loading"
  [emptyMessage]="emptyMessage"
  [dropdownOpenRowIndex]="openDropdownRowIndex"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
>
  <ng-template #policyStatusCell let-row>
    <span
      *ngIf="row.policyStatus && row.policyStatus !== '-'; else noPolicyStatus"
      class="created-policies-details__status"
      [ngClass]="getStatusChipClass(row.policyStatus)"
    >
      {{ row.policyStatus }}
    </span>
    <ng-template #noPolicyStatus>
      <span class="created-policies-access-types__empty">-</span>
    </ng-template>
  </ng-template>

  <ng-template #accessTypeCell let-row>
    <div class="created-policies-access-types" *ngIf="row.accessTypes?.length; else noAccessType">
      <span
        *ngFor="let type of row.accessTypes"
        class="created-policies-chip"
        [ngClass]="getAccessTypeChipClass(type)"
      >
        {{ formatAccessTypeLabel(type) }}
      </span>
    </div>
    <ng-template #noAccessType>
      <span class="created-policies-access-types__empty">-</span>
    </ng-template>
  </ng-template>

  <ng-template #approvedByCell let-row>
    <div class="created-policies-approved-by" *ngIf="hasApprovedByValue(row); else noApprovedBy">
      <span class="created-policies-approved-by__name" [attr.title]="row.approvedByName">{{ row.approvedByName }}</span>
      <span
        class="created-policies-approved-by__role"
        *ngIf="row.approvedByRole"
        [attr.title]="row.approvedByRole"
      >{{ row.approvedByRole }}</span>
    </div>
    <ng-template #noApprovedBy>
      <span class="created-policies-access-types__empty">-</span>
    </ng-template>
  </ng-template>

  <ng-template #createdByCell let-row>
    <div class="created-policies-approved-by" *ngIf="hasCreatedByValue(row); else noCreatedBy">
      <span class="created-policies-approved-by__name" [attr.title]="row.createdByName">{{ row.createdByName }}</span>
      <span
        class="created-policies-approved-by__role"
        *ngIf="row.createdByRole"
        [attr.title]="row.createdByRole"
      >{{ row.createdByRole }}</span>
    </div>
    <ng-template #noCreatedBy>
      <span class="created-policies-access-types__empty">-</span>
    </ng-template>
  </ng-template>

  <ng-template #actionCell let-row>
    <div class="action-cell-wrapper" [class.action-dropdown-open]="isDropdownOpen(row)">
      <button
        type="button"
        class="action-btn"
        appActionDropdownTrigger
        (click)="toggleActionDropdown($event, row)"
        [class.active]="isDropdownOpen(row)"
      >
        <span>Action</span>
      </button>

      <div
        class="action-dropdown-menu action-dropdown-menu--fixed"
        *ngIf="isDropdownOpen(row)"
        [style.top.px]="dropdownPosition.top"
        [style.left.px]="dropdownPosition.left"
        [style.right.px]="dropdownPosition.right"
        (click)="$event.stopPropagation()"
      >
        <ul class="dropdown-list">
          <li class="dropdown-item">
            <button type="button" class="dropdown-link" (click)="onViewDetails(row)">View details</button>
          </li>
          <li class="dropdown-item" *ngIf="showDeletePolicyAction(row)">
            <button type="button" class="dropdown-link" (click)="onDeletePolicy(row)">Revoke</button>
          </li>
          <li class="dropdown-item" *ngIf="canConverse(row)">
            <button type="button" class="dropdown-link" (click)="openConversation(row)">Conversation</button>
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</app-table>

<app-confirmation-dialog
  [(visible)]="showDeleteConfirmModal"
  type="delete"
  themeColor="red"
  title="Revoke Policy"
  [message]="getDeletePolicyConfirmMessage()"
  confirmLabel="Revoke"
  cancelLabel="Cancel"
  [loading]="isDeleting"
  (onConfirm)="onConfirmDeletePolicy()"
  (onCancel)="onCancelDeletePolicy()"
></app-confirmation-dialog>

<app-modal
  [(visible)]="detailsModalVisible"
  header="Policy details"
  width="820px"
  styleClass="custom-modal created-policies-details-modal"
  [showConfirmButton]="false"
  cancelLabel="Close"
  (onCancel)="closeDetailsModal()"
  (onClose)="closeDetailsModal()"
>
  <div class="pd" *ngIf="selectedPolicyDetails as details">

    <!-- ── Hero banner ─────────────────────────────────────────── -->
    <header class="pd__hero">
      <div class="pd__hero-left">
        <div class="pd__asset-icon" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
          </svg>
        </div>
        <div class="pd__hero-text">
          <h3 class="pd__asset-name">{{ details.asset.assetName }}</h3>
          <div class="pd__hero-badges">
            <span class="pd__badge pd__badge--type" *ngIf="details.asset.assetType && details.asset.assetType !== '-'">
              {{ details.asset.assetType }}
            </span>
            <span class="pd__badge pd__status" [ngClass]="getStatusChipClass(details.status)">
              {{ details.status }}
            </span>
          </div>
        </div>
      </div>
      <div class="pd__hero-expiry">
        <span class="pd__expiry-label">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
          Expires
        </span>
        <span class="pd__expiry-value">{{ details.expiryAt }}</span>
      </div>
    </header>

    <!-- ── Policy scope ────────────────────────────────────────── -->
    <section class="pd__scope" *ngIf="showScopeSection(details)">
      <div class="pd__scope-head">
        <div class="pd__scope-head-icon" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
        </div>
        <div class="pd__scope-head-text">
          <h4 class="pd__scope-title">Policy scope</h4>
          <p class="pd__scope-subtitle">Defines who this policy applies to</p>
        </div>
      </div>

      <div class="pd__scope-grid">
        <div class="pd__scope-tile" *ngIf="details.policyType && details.policyType !== '-'">
          <div class="pd__scope-tile-icon" [ngClass]="getPolicyTypeTileClass(details.policyType)">
            <svg *ngIf="isGroupPolicyType(details.policyType)" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
            <svg *ngIf="!isGroupPolicyType(details.policyType)" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
          </div>
          <span class="pd__scope-tile-label">Policy type</span>
          <span class="pd__scope-tile-value">{{ details.policyType }}</span>
        </div>

        <div class="pd__scope-tile" *ngIf="details.user.organization && details.user.organization !== '-'">
          <div class="pd__scope-tile-icon pd__scope-tile-icon--org">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
          </div>
          <span class="pd__scope-tile-label">Organisation</span>
          <span class="pd__scope-tile-value pd__scope-tile-value--wrap">{{ details.user.organization }}</span>
        </div>

        <div class="pd__scope-tile pd__scope-tile--roles" *ngIf="details.allowedRoles.length">
          <div class="pd__scope-tile-icon pd__scope-tile-icon--roles">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
            </svg>
          </div>
          <span class="pd__scope-tile-label">Allowed roles</span>
          <div class="pd__scope-tile-chips">
            <span *ngFor="let role of details.allowedRoles" class="pd__scope-role-chip">
              {{ formatRoleLabel(role) }}
            </span>
          </div>
        </div>
      </div>
    </section>

    <!-- ── People cards (Owner + User) ────────────────────────── -->
    <div class="pd__people">
      <div class="pd__person-card" *ngIf="hasPersonDetails(details.owner)">
        <div class="pd__person-header">
          <div class="pd__avatar pd__avatar--owner">{{ getInitials(details.owner) }}</div>
          <div>
            <p class="pd__person-name">{{ getDisplayName(details.owner) }}</p>
            <p class="pd__person-role-label">Owner · <span>Granted by</span></p>
          </div>
        </div>
        <ul class="pd__person-fields">
          <li class="pd__person-field">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            <span class="pd__person-field-val">{{ details.owner.email }}</span>
          </li>
          <li class="pd__person-field" *ngIf="details.owner.organization && details.owner.organization !== '-'">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
            <span class="pd__person-field-val">{{ details.owner.organization }}</span>
          </li>
        </ul>
      </div>

      <div class="pd__person-card" *ngIf="hasPersonDetails(details.user)">
        <div class="pd__person-header">
          <div class="pd__avatar pd__avatar--user">{{ getInitials(details.user) }}</div>
          <div>
            <p class="pd__person-name">{{ getDisplayName(details.user) }}</p>
            <p class="pd__person-role-label">User · <span>Granted to</span></p>
          </div>
        </div>
        <ul class="pd__person-fields">
          <li class="pd__person-field">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            <span class="pd__person-field-val">{{ details.user.email }}</span>
          </li>
          <li class="pd__person-field" *ngIf="details.user.organization && details.user.organization !== '-'">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
            <span class="pd__person-field-val">{{ details.user.organization }}</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- ── Access constraints ──────────────────────────────────── -->
    <section class="pd__section">
      <h4 class="pd__section-title">Access constraints</h4>
      <ng-container *ngIf="details.accessConstraints.length; else noConstraints">
        <div class="pd__constraint" *ngFor="let constraint of details.accessConstraints">
          <div class="pd__constraint-left">
            <span class="created-policies-chip" [ngClass]="getAccessTypeChipClass(constraint.accessType)">
              {{ formatAccessTypeLabel(constraint.accessType) }}
            </span>
          </div>
          <div class="pd__constraint-expiry">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span class="pd__constraint-expiry-label">Expiry Date</span>
            <span class="pd__constraint-expiry-value">{{ constraint.expiry }}</span>
          </div>
        </div>
      </ng-container>
      <ng-template #noConstraints>
        <p class="pd__empty">No access constraints configured</p>
      </ng-template>
    </section>

    <!-- ── Comments ──────────────────────────────────────────── -->
    <section class="pd__section pd__comments" *ngIf="showCommentsSection(details)">
      <h4 class="pd__section-title">Comments</h4>
      <div class="pd__comments-grid">
        <div class="pd__comment" *ngIf="showInternalNotes(details)">
          <span class="pd__comment-label">Notes</span>
          <p class="pd__comment-text">{{ details.providerComment }}</p>
        </div>
        <div class="pd__comment" *ngIf="showRequesterComment(details)">
          <span class="pd__comment-label">Requester comment</span>
          <p class="pd__comment-text">{{ details.feedbackToConsumer }}</p>
        </div>
      </div>
    </section>

    <!-- ── Timeline footer ────────────────────────────────────── -->
    <footer class="pd__timeline">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
      <span>Created {{ details.createdAt }}</span>
      <span *ngIf="showSecondaryTimestamp(details)" class="pd__timeline-dot">·</span>
      <span *ngIf="showSecondaryTimestamp(details)">{{ getSecondaryTimestampLabel() }} {{ details.updatedAt }}</span>
    </footer>

  </div>
</app-modal>

<app-modal
  [(visible)]="addPolicyModalVisible"
  header="Add New Policy"
  width="960px"
  styleClass="custom-modal custom-modal--allow-overlay-overflow created-policies-add-policy-modal"
  [showFooter]="false"
  (onCancel)="closeAddPolicyModal()"
  (onClose)="closeAddPolicyModal()"
>
  <app-add-policy-home
    *ngIf="addPolicyModalVisible"
    [embedded]="true"
    (policySaved)="onAddPolicySaved()"
    (cancelled)="closeAddPolicyModal()"
  ></app-add-policy-home>
</app-modal>
